(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ln2-education"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(scope) {
  scope.querySelectorAll('.ln2-education').forEach(root => {
   if (root.dataset.ready) return;
   root.dataset.ready='true';
   const tabs=[...root.querySelectorAll('[role="tab"]')];
   function activate(tab,focus=false) { tabs.forEach(button=>{const active=button===tab;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;const panel=root.querySelector('#'+CSS.escape(button.getAttribute('aria-controls')));if(panel)panel.hidden=!active;});if(focus)tab.focus(); }
   tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next],true);}});});
   const filters=[...root.querySelectorAll('[data-review-filter]')],cards=[...root.querySelectorAll('[data-review-category]')],more=root.querySelector('.ln2-ed-more');
   let selected='all',limit=6;
   function renderReviews(){const matching=cards.filter(card=>selected==='all'||card.dataset.reviewCategory===selected);cards.forEach(card=>card.hidden=true);matching.slice(0,limit).forEach(card=>card.hidden=false);filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.reviewFilter===selected)));if(more)more.hidden=matching.length<=limit;}
   filters.forEach(button=>button.addEventListener('click',()=>{selected=button.dataset.reviewFilter;limit=6;renderReviews();}));
   if(more)more.addEventListener('click',()=>{limit+=6;renderReviews();});
   renderReviews();
  });
 }
 init(document);
 document.addEventListener('shopify:section:load',()=>init(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
